<template>
  <v-dialog v-model="visible" max-width="900px">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-form>
          <v-row>
            <v-col cols="12" lg="4">
              <v-text-field v-model="form.codigo" label="Código" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.codigo" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" lg="8">
              <v-text-field v-model="form.nombre" label="Nombre" outlined dense hide-details clearable></v-text-field>

              <small v-for="error in errores.nombre" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="7" lg="8">
              <vue-select
                v-model="form.universidadId"
                class="style-chooser"
                placeholder="Seleccione una institución"
                :options="instituciones"
                label="nombre"
                :append-to-body="true"
                :reduce="(option) => option.id">
              </vue-select>

              <small v-for="error in errores.universidadId" :key="error" class="d-block text-danger">{{ error }}</small>
            </v-col>

            <v-col cols="12" md="5" lg="4">
              <v-select
                v-model="form.unidadNegocioId"
                :items="unidadesNegocios"
                label="Unidad de Negocio"
                outlined
                dense
                hide-details
                item-text="nombre"
                item-value="id"
                clearable
                :disabled="unidadesNegocios.length == 0">
                <template #item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>

                    <v-list-item-subtitle>
                      <small>{{ item.codigo }}</small>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-select>

              <small v-for="error in errores.unidadNegocioId" :key="error" class="d-inline-block text-danger">
                {{ error }}
              </small>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text :disabled="enviando" @click.prevent="cerrar"> Cerrar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          :disabled="enviando"
          :loading="enviando"
          @click.prevent="() => validar(registrar, editar)">
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import 'vue-select/dist/vue-select.css';
import SedeUniversidadService from '../services/sede-universidad.service';
import InstitucionService from '../services/institucion.service';
import SedeService from '../services/sede.service';
import modalFormMixin from '../mixins/modal-form.mixin';
import apiConsumerMixin from '../mixins/api-consumer.mixin';
import UnidadNegocioService from '../services/unidades-negocios.service';

export default {
  name: 'ModalFormularioSedeUniversidad',
  mixins: [modalFormMixin, apiConsumerMixin],
  data() {
    return {
      sedes: [],
      instituciones: [],
      unidadesNegocios: [],
    };
  },
  watch: {
    'form.codigo': function () {
      this.errores.codigo = [];
    },
    'form.nombre': function () {
      this.errores.nombre = [];
    },
    'form.universidadId': function () {
      this.errores.universidadId = [];
    },
    'form.unidadNegocioId': function () {
      this.errores.unidadNegocioId = [];
    },
  },
  methods: {
    generarObjetoFormRegistrar() {
      return {
        id: null,
        codigo: null,
        nombre: null,
        universidadId: null,
        unidadNegocioId: null,
      };
    },
    generarObjetoFormEditar(data) {
      return {
        id: data.id,
        codigo: data.codigo,
        nombre: data.nombre,
        universidadId: data.universidadId,
        unidadNegocioId: data.unidadNegocioId,
      };
    },
    async obtenerSedes() {
      await this.obtenerDatosMixin(SedeService.findAll, 'sedes');
    },
    async obtenerInstituciones() {
      await this.obtenerDatosMixin(InstitucionService.findAll, 'instituciones');
    },
    async obtenerUnidadesNegocios() {
      await this.obtenerDatosMixin(UnidadNegocioService.findAll, 'unidadesNegocios');
    },
    abrir(accion, data = []) {
      this.obtenerSedes();
      this.obtenerInstituciones();
      this.obtenerUnidadesNegocios();
      this.abrirMixin(accion, data);
    },
    guardar(accion) {
      this.guardarDatosMixin(
        SedeUniversidadService.create,
        SedeUniversidadService.update,
        accion,
        this.form,
        this.nombreRecurso,
        () => {
          this.$emit('actualizarListado');
          this.cerrar();
        },
        (errores) => {
          this.errores = errores;
        },
      );
    },
    registrar() {
      this.guardar(this.accionesCrud.REGISTRAR);
    },
    editar() {
      this.guardar(this.accionesCrud.EDITAR);
    },
  },
};
</script>

<style scoped>
::v-deep .v-select.v-text-field--outlined:not(.v-text-field--single-line).v-input--dense .v-select__selections {
  padding: 0px 0;
}

::v-deep .v-text-field .v-input__control .v-input__slot {
  min-height: auto !important;
  display: flex !important;
  align-items: center !important;
}

::v-deep .v-text-field--outlined.v-input--dense .v-label {
  top: 5px;
}

::v-deep .v-text-field .v-label {
  font-weight: 400;
}
</style>